import React from "react";
import TableV2 from "../TableV2/tableV2";
import { useFetchChargesQuery } from "../../Apis/stripeChargesApi";
import { CardChargeHistory } from "../../Model/paymentObjects";
import { DATE_FORMATS, formatDate } from "../../Util/dateUtils";

const InvoiceViewBtn = ({link}) => {
    return <a className="invoiceLink" href={link} rel="noreferrer" target="_blank" title={"Click to view Detailed Invoice"}>view</a>
}

const NoInvoicesText = "You do not have any invoices"

const columnConfig = [
    {
        id: "status",
        label: "Status",
        data: (x) => {
            if (x.getPaymentMethodType() === "US_BANK_ACCOUNT") {
                return x.getSuccess() ? "Paid" : "Pending";
            } else if (x.getPaymentMethodType() === "CARD") {
                return x.getSuccess() ? "Paid" : "Failed";
            }
            return "N/A";
        }
    },
    {
        id: "date",
        label: "Date",
        data: (x) => formatDate(x.getChargeTime(), DATE_FORMATS.MMM_DDc_YYYY),
    },
    {
        id: "amount",
        label: "Amount (USD)",
        data: (x) => Number(x.getPaidAmountInUsd()).toFixed(2),
    },
    {
        id: "source",
        label: "Source",
        data: (x) => x.getSourceDisplayText(),
    },
    {
        id: "action",
        label: "",
        data: (x) => x.getSuccess() ? <InvoiceViewBtn link={x.getInvoiceUrl()} /> : ""
    },
];

const tableConfig = {
    columns: columnConfig,
    pagination: false,
    scrollable: false,
};

const InvoicesTableSection = () => {
    const { data: chargeHistoryData } = useFetchChargesQuery();
    const cardChargeHistory = chargeHistoryData ? new CardChargeHistory(chargeHistoryData) : new CardChargeHistory([]);
    
    return (
        <div className="row mt-4">
            <span className="sub-title mt-3">Invoices</span>
            <div style={{ width: "100%" }}>
                <TableV2 data={cardChargeHistory.getCharges()} config={tableConfig} emptyText={NoInvoicesText} />
            </div>
        </div>
    )
}

export default InvoicesTableSection;
